export default __webpack_public_path__ + "static/media/sync-with-cb.2e3d743a.jpg";